import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../../helpers.js';

export default class extends Controller {
  static targets = [
    'form',
    'selector',
    'amountInput',
    'feesInput',
    'amountInputErrorMessage',
    'button',
    'selectedInvestor',
    'subscriptionAmount',
    'feesAmount',
    'displayAmount',
    'displayFees',
    'displayTotal',
  ];

  connect() {
    this.updateModalInvestor();
    this.updateModalAmount();
    this.toggleSubscribeButton();
  }

  preventEnterOnForm(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  handleSelectorChange(event) {
    this.updateModalInvestor();
    this.toggleSubscribeButton();
  }

  handleSubscriptionChange(event) {
    const amount = parseInt(event.target.value, 10);
    const projectShareValue = event.target.dataset.projectShareValue;
    const feesUrl = event.target.dataset.feesUrl;
    const projectId = event.target.dataset.projectId;

    if (Helpers.numberIsMultipleOf(amount, projectShareValue)) {
      this.amountInputErrorMessageTarget.classList.add('d-none');
      this.amountInputErrorMessageTarget.textContent = '';

      this.subscriptionAmountTarget.textContent = amount;

      if (this.hasDisplayAmountTarget) {
        this.displayAmountTarget.textContent = Helpers.numberToCurrency(amount, 2);
      }

      this.fetchFees(feesUrl, amount, projectId);
      this.toggleSubscribeButton();
    } else {
      if (isNaN(amount)) {
        this.amountInputErrorMessageTarget.classList.add('d-none');
        this.amountInputErrorMessageTarget.textContent = '';
      } else {
        const [previousMultiple, nextMultiple] = Helpers.closestMultiplesOf(amount, projectShareValue);
        const errorMessage =
          'Veuillez saisir une valeur valide.' +
          ' Les deux valeurs valides les plus proches' +
          ` sont ${previousMultiple} ou ${nextMultiple}.`;
        this.amountInputErrorMessageTarget.classList.remove('d-none');
        this.amountInputErrorMessageTarget.textContent = errorMessage;
      }

      this.buttonTarget.disabled = true;
    }
  }

  updateModalInvestor() {
    if (this.hasSelectorTarget && this.hasSelectedInvestorTarget) {
      const tomselect = this.selectorTarget.tomselect;
      if (tomselect) {
        const selectedValue = tomselect.getValue();
        const selectedOption = tomselect.options[selectedValue];
        if (selectedOption) {
          this.selectedInvestorTarget.textContent = selectedOption.text;
        }
      }
    }
  }

  updateModalAmount() {
    if (this.hasAmountInputTarget && this.hasSubscriptionAmountTarget) {
      this.subscriptionAmountTarget.textContent = this.amountInputTarget.value || '';
    }
  }

  toggleSubscribeButton() {
    if (!this.hasButtonTarget || !this.hasSelectorTarget || !this.hasAmountInputTarget) {
      return;
    }

    const tomselect = this.selectorTarget.tomselect;
    const hasSelectedInvestor = tomselect && tomselect.getValue() !== '';
    const amount = this.amountInputTarget.value;
    const projectShareValue = this.amountInputTarget.dataset.projectShareValue;

    this.buttonTarget.disabled = !(hasSelectedInvestor && Helpers.numberIsMultipleOf(amount, projectShareValue));
  }

  fetchFees(feesUrl, amount, projectId) {
    const url = `${feesUrl}?amount=${amount}&project_id=${projectId}`;

    fetch(url, {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const feesAmount = parseFloat(data.fees_amount) || 0;
        this.feesInputTarget.value = feesAmount;
        if (this.hasFeesAmountTarget) {
          this.feesAmountTarget.textContent = Helpers.numberToCurrency(feesAmount, 2);
        }
        if (this.hasDisplayFeesTarget) {
          this.displayFeesTarget.textContent = Helpers.numberToCurrency(feesAmount, 2);
        }
        if (this.hasDisplayTotalTarget) {
          const amount = parseInt(this.amountInputTarget.value, 10) || 0;
          this.displayTotalTarget.textContent = Helpers.numberToCurrency(amount + feesAmount, 2);
        }
      })
      .catch(() => {
        this.amountInputErrorMessageTarget.classList.remove('d-none');
        this.amountInputErrorMessageTarget.textContent = 'Une erreur s\'est produite, veuillez réessayer.';
      });
  }
}
